import {useMediaQuery} from '@mui/material'
import {FC, useRef, useState} from 'react'
import {useWallet} from 'entities/payment'
import {useUser} from 'entities/user'
import {Packages} from 'features/packages'
import {Sidebar} from 'features/sidebar'
import {names} from 'shared/lib'
import {text} from 'shared/mirrors/text'
import {HorizontalDivider} from 'shared/ui/dividers'
import {List, ArrowDown, GoCoin41, Image, PlayCircle, GiftFill, NoteSticky} from 'shared/ui/icons'
import {BottomMenu} from 'widgets/bottomMenu'
import {HeaderDesktop, HeaderMobile} from 'widgets/header'
import styles from './styles.module.scss'
import {Advantages} from './ui/advantages'

const DEFAULT_ADVANTAGE_COUNT = 2

export const CreditsPage = () => {
  const wallet = useWallet()
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)
  const {paymentsCount} = useUser()
  const [isActiveDisclosure, setIsActiveDisclosure] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)

  return (
    <div className={styles.root}>
      {is768p ? <HeaderMobile wrapperRef={ref} /> : <HeaderDesktop />}
      <div className={names(styles.customScroll, styles.creditsPageScroll)} ref={ref}>
        <div className={styles.wrapper}>
          {is768p ? null : <Sidebar className={styles.sidebar} />}
          <div className={styles.content}>
            <div className={names(styles.banner, paymentsCount < 1 && styles.single)}>
              <div className={styles.balance}>
                <div className={styles.yourBalance}>
                  <h5 className={styles.title}>My balance</h5>
                  <div className={styles.balanceWrapper}>
                    <h1>{(wallet.credits + wallet.freeCredits).toFixed(2)}</h1>
                    <GoCoin41 />
                  </div>
                </div>

                <div className={styles.actionsLeft}>
                  <div className={styles.actionsLeft__item}>
                    <div className={styles.icon}><NoteSticky /></div>
                    <span className={styles.text}>x{wallet.stickers}</span>
                  </div>
                  <div className={styles.actionsLeft__item}>
                    <div className={styles.icon}><Image /></div>
                    <span className={styles.text}>x{wallet.photos}</span>
                  </div>
                  <div className={styles.actionsLeft__item}>
                    <div className={styles.icon}><PlayCircle /></div>
                    <span className={styles.text}>x{wallet.videos}</span>
                  </div>
                  <div className={styles.actionsLeft__item}>
                    <div className={styles.icon}><GiftFill /></div>
                    <span className={styles.text}>x{wallet.virtualGifts}</span>
                  </div>
                </div>
              </div>

              {paymentsCount > 0 ?
                <div
                  className={names(
                    styles.disclosure,
                    isActiveDisclosure && styles.active
                  )}
                  onClick={() => setIsActiveDisclosure(!isActiveDisclosure)}
                >
                  <div className={styles.disclosureHeader}>
                    <List className={styles.disclosureHeaderIconList} />
                    <h5 className={styles.disclosureHeaderTitle}>
                        What each package includes?
                    </h5>
                    <ArrowDown className={styles.disclosureHeaderIconChevron} />
                  </div>
                  <div className={styles.disclosurePanel}>
                    <div className={styles.disclosurePanelAdvantagesWrapper}>
                      <Advantages className={styles.disclosurePanelAdvantages} />
                    </div>
                  </div>
                </div>
                : null}

              {is768p ?
                <div className={styles.advantagesWrapper}>
                  <HorizontalDivider />
                  <h5 className={styles.title}>What each package includes?</h5>
                  <Advantages displayItemsCount={DEFAULT_ADVANTAGE_COUNT} />
                </div>
                : null}
            </div>
            <Packages />
            <div className={styles.companies}>
              <p>{text.main.estoniaAddress} and its affiliates</p>
            </div>
          </div>
        </div>
      </div>
      {is768p ? <BottomMenu /> : null}
    </div>
  )
}
